import { useEffect, useState } from 'react';

const useWindowSize = (): [number, number] => {
  const [size, setSize] = useState<[number, number]>(() => [
    typeof window !== 'undefined' ? window.innerWidth : 0,
    typeof window !== 'undefined' ? window.innerHeight : 0,
  ]);

  useEffect(() => {
    const updateSize = (): void => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    updateSize();
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('resize', updateSize);
      return () => window.removeEventListener('resize', updateSize);
    }
  }, []);

  return [size[0], size[1]];
};

export default useWindowSize;
